module.exports = __webpack_public_path__ + "web/img/sign_in.6ea40d78.png";